var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"to":{ name: _vm.name },"height":"100%","disabled":!_vm.name}},[_c('v-img',{attrs:{"max-height":"150","src":_vm.image,"contain":_vm.contain}}),_c('v-card-title',{},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-subtitle',[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }